/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateListingRequest} from '@cash-web/protos/squareup/cash/cashbusinesspayments/api/v1beta1/listing.pb'
import {CreateListingResponse} from '@cash-web/protos/squareup/cash/cashbusinesspayments/api/v1beta1/listing.pb'


export const createListing = (request: CreateListingRequest, options?: CashRequestOptions) => post<CreateListingRequest, CreateListingResponse>("/2.0/cash/create-listing", request, {...options, rejectOnError: true })